// extracted by mini-css-extract-plugin
export default {"root":"SpecFieldIcon_root__At7am","imageIcon":"SpecFieldIcon_imageIcon__32v3C"};